import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { submitCart, cart, currentOrder, updateItemQuantity, submitCCStatus, submitStatus, removeItemFromOrder } from '../reducers/cart';

import { getUser, getSubsite, reloadUser } from '../reducers/auth';
import { useNavigate } from "react-router-dom";
import AddressModal from "./modals/AddressModal";
import ShippingService from "../services/shipping.service";
import PaymentService from "../services/payment.service";
import { Container, Row, Col } from "react-bootstrap";

const Checkout = () => {
  let navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const cartItems = useSelector(cart);
  const currOrder = useSelector(currentOrder);
  const submitted = useSelector(submitStatus);
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const [ paymentType, setPaymentType ] = useState("balance");
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  const [ alertMessage, setAlertMessage ] = useState('');
  const [ token, setToken ] = useState('');
  const ccStatus = useSelector(submitCCStatus);
  const currentSubsite = useSelector(getSubsite);
  const [ shipping, setShipping ] = useState();
  const [total, setTotal ] = useState(0.0);

  console.log("CURRENT SUBSITE", currentSubsite);
  let content = "";
  let totalCount = 0;
  let weight = 0.0;
  let shippingCost = null;

  useEffect(() => {
    dispatch(reloadUser());
  }, []);

useEffect(() => {
  
  console.log("CART ITEMS", cartItems);
  var newtotal = 0.0;
  totalCount = 0.0;

  for(var i=0; i<cartItems.length; i++) {
    newtotal += cartItems[i].price * cartItems[i].quantity;
    totalCount += cartItems[i].quantity;
  }
  if(user.subsiteBalance && newtotal > user.subsiteBalance.balance) {
    setPaymentType("split");
    getShipping("split");
  } else {
    setPaymentType("balance");
    getShipping("balance");
  }
  setTotal(newtotal);

}, [cartItems, user]);
//  useEffect(() => {
//    });
//}, [currOrder]);

  /*cartItems.map(item => {
    total += item.price * item.quantity;
    totalCount += item.quantity;
  });*/
  
  useEffect(() => {
    async function fetchData() {
      var newTotal = 0.0;
      for(var i=0; i<cartItems.length; i++) {
        newTotal += cartItems[i].price * cartItems[i].quantity;
      }
      console.log("NEW TOTAL", newTotal);
      setTotal(newTotal);
    }
    fetchData();
  }, []);

  const typeChanged = (event) => {
    setPaymentType(event.target.id);
  }

  const handleOrder = (event) => {
    navigate("/payment");
  }

  const removeCartItem = (item) => {
    console.log("CART ITEM", item);
    dispatch(removeItemFromOrder(item.id));
  }

  const formatPantsSize = (sizeName) => {
    var isFour =  /^\d{4}$/.test(sizeName);
    if(isFour) {
      return sizeName.substring(0,2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }

  const getShipping = async (type) => {
    if(!type) type = paymentType;
    weight = 0.0;
    cartItems.map(item => {
      weight += item.product.weight * item.quantity;
    });

    console.log("GET SHIPPING", weight);
    //var shipping = await ShippingService.getShipping({weight: weight, orderId: currOrder.id, paymentType: type, balance: user.balance});
    console.log("GET SHIPPING2", shipping);
    //setShipping(shipping.data);
    //shippingCost = shipping.data;
  }


  const qtyChanged = (item, event) => {
    let args = {item: item, quantity: parseInt(event.target.value)};
    dispatch(updateItemQuantity(args));
  }

  return (
    <div className="container" style={{paddingTop: 20, paddingBottom: 100}}>
      {cartItems.length === 0 && (
        <div class="alert">Your cart is empty. Please add items to your cart before checking out.</div>
      )}
      {cartItems.length > 0 && (
        <>
      <Container>
        <Row>
        <Col xs={12} style={{marginLeft: 40}}>
                  {currentSubsite.paymentOptions.includes("balance") && (
                <div class="content">
                    {total > user.balance &&
                        <div class="alert">Your total is more than your available balance. 
                          Your balance will be used up and the remaining balance will charged to your credit card.<br/>
                          Balance Remaining: {user.subsiteBalance.balance.toLocaleString(undefined, { style: "currency",
  currency: "USD",})}
                        </div>
                    }
                    </div>
                  )}
        </Col>
        </Row>
        </Container>

        <div>
            <div class="review-container">
                <div class="content">

                    <div class="cart-item-container">
                        <div class="price-label">PRICE</div>
                        <Container className="mt-5" style={{ marginBottom: "150px" }}>
                        {cartItems.map(item => {
                        return (
                          <Row className="checkout-item">
                          <Col sm={3} className="d-flex justify-content-center align-items-center">
                            <div style={{position: "relative", width: "150px"}}>
              <img className="bg-image" src={item.product.frontModelImage} width={150}></img>
              {item.decorations && item.decorations.map((logo, i) => (
                    <img className="logo-image" src={apiUrl + logo.imageUrl} width={logo.width+'%'} style={{left: logo.x+'%',top: logo.y+'%', transform: 'rotate('+logo.rotate+'deg)' }}></img>
                )
              )}  
            
          </div>
          </Col>
          <Col sm={7}>
                            <div class="content" style={{position: "relative"}}>
                                <div class="title">{item.product.style.title}</div>
                                <div class="color">Color: {item.colorName}</div>
                                <div class="size-name">Size: {formatPantsSize(item.sizeName)}</div>
                                <div class="quantity">
                                <Form.Select label="Quantity" onChange={(event) => qtyChanged(item, event)} value={item.quantity}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                </Form.Select>
                                </div>
                                <Button variant="primary" onClick={() => { removeCartItem(item) }}>Remove</Button>
                            </div>
              </Col>
              <Col sm={2}>
                            <div class="price" style={{textAlign: "right", justifyContent: "flex-end"}}>{(item.price * item.quantity).toLocaleString(undefined, { style: "currency", currency: "USD"})}</div>
                          </Col>
                          </Row>
                        );})

                        }
                        </Container>
                        <div class="total">Subtotal: <strong>{(total).toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</strong><br/></div>
                        {shipping && shipping.shippingAmount && (
                        <div class="total">Shipping: <strong>{(shipping?.shippingAmount?.amount).toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</strong><br/></div>
                        )}
                        {user.subsiteBalance?.balance > 0 && (
                        <div class="total">Balance: <strong>-{(user.subsiteBalance?.balance).toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</strong><br/></div>
                        )}
              <Button variant="warning" disabled={isSubmitting}
                 onClick={handleOrder}>Continue to Payment</Button>
                    </div> 
                </div>
            </div>
        </div>
        </>
        )}
      </div>
  );
};
export default Checkout;